import React from "react";
import Text from "components/Text";
import "../UpcomingTabs/UpcomingTabs.scss";
import { Portal } from "react-overlays";
import ReactDatePickerCommon from "components/ReactDatePickerCommon";

const DateFilter = ({ t, dates, updateDatesValues }) => {
  const errors = {};

  const CalendarContainer = ({ children }) => {
    const el = document.getElementById("calendar-portal");

    return <Portal container={el}>{children}</Portal>;
  };

  return (
    <>
      <Text size="12px" marginBottom="12px" weight="400" color="#102C42">
        {t("accountOwner.dateRange")}
      </Text>

      <div className="invitation_date_picker">
        <div className="invitation_date">
          <div className="c-field">
            <label>{t("from")}</label>
            <div className="d-flex inputdate">
              <ReactDatePickerCommon
                dateFormat="dd-MM-yyyy"
                className="c-form-control"
                selected={dates.from}
                onChange={(e) => updateDatesValues(e, "from")}
                maxDate={dates.to}
                popperPlacement="bottom-start"
                popperContainer={CalendarContainer}
              />
              {errors.from && (
                <span className="error-msg" style={{ display: "inline" }}>
                  {errors.from}
                </span>
              )}
            </div>
          </div>
        </div>
        <div className="invitation_date">
          <div className="c-field">
            <label>{t("to")}</label>
            <div className="d-flex inputdate">
              <ReactDatePickerCommon
                dateFormat="dd-MM-yyyy"
                className="c-form-control"
                selected={dates.to}
                minDate={dates.from}
                onChange={(e) => updateDatesValues(e, "to")}
                popperPlacement="bottom-end"
                popperContainer={CalendarContainer}
              />
              {errors.to && (
                <span className="error-msg" style={{ display: "inline" }}>
                  {errors.to}
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DateFilter;
